// extracted by mini-css-extract-plugin
module.exports = {"container":"SnackbarContainer_container__WTtyX"};